module.exports = __webpack_public_path__ + "img/widget-img_symbols.a58536bb.png";